module.exports = __webpack_public_path__ + "img/CapitalOne.1aed875f.svg";